import React from "react";
import { Link } from "react-router-dom";

const Queue = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white shadow-lg rounded-xl p-8 max-w-xl text-center">
        <h1 className="text-2xl font-bold text-green-600 mb-4">Thank You for Registering!</h1>
        <p className="text-gray-700 mb-4">
          We’ve successfully received your information.
        </p>
        <p className="text-gray-700 mb-4">
          Your account request has been added to our verification queue.
        </p>
        <p className="text-gray-700 mb-6">
          Once your account is verified, you’ll receive a confirmation email.  
          After that, you’ll be able to log in and start selling with Khushhali.
        </p>
        <Link to="/login" className="text-blue-600 font-medium hover:underline">
          &larr; Back to Login
        </Link>
      </div>
    </div>
  );
};

export default Queue;
